import React from 'react';
import PropTypes from 'prop-types';
import { BikeScoreSvg, ScoreBadge } from '~/legacy/components';

function BikeScoreBadge({
  bikeScore,
  description,
  helpLink,
  titleVariant,
  fontSize,
  height,
  x,
  y,
}) {
  const bikeScoreSvg = (
    <BikeScoreSvg
      bikeScore={bikeScore}
      fontSize={fontSize}
      height={height}
      x={x}
      y={y}
    />
  );
  return (
    <ScoreBadge
      scoreName="Bike Score"
      scoreSvg={bikeScoreSvg}
      titleVariant={titleVariant}
      description={description}
      helpLink={helpLink}
    />
  );
}
BikeScoreBadge.propTypes = {
  bikeScore: PropTypes.number.isRequired,
  description: PropTypes.string,
  helpLink: PropTypes.string.isRequired,
  titleVariant: PropTypes.string,
  fontSize: PropTypes.string,
  height: PropTypes.string,
  x: PropTypes.string,
  y: PropTypes.string,
};
BikeScoreBadge.defaultProps = {
  description: undefined,
  titleVariant: undefined,
  fontSize: undefined,
  height: undefined,
  x: undefined,
  y: undefined,
};

export default BikeScoreBadge;
